import { CheckoutForm } from "@circle-react/components/Paywalls/Checkout/CheckoutV2/CheckoutForm";
import { CheckoutFormField } from "./CheckoutFormField";

export const CheckoutFormBusinessNameField = () => (
  <CheckoutForm.Item name="business_name" optional>
    <CheckoutFormField
      type="text"
      name="community_member_billing_info_attributes[business_name]"
      options={{
        maxLength: 200,
      }}
    />
  </CheckoutForm.Item>
);
